import { Container, Text } from "pixi.js";
import { UpgradeTutorialWhiteTextStyle } from "./styles/UpgradeTutorialWhiteTextStyle";
import { UpgradeTutorialGreenTextStyle } from "./styles/UpgradeTutorialGreenTextStyle";
import { UpgradeTutorialPurpleTextStyle } from "./styles/UpgradeTutorialPurpleTextStyle";
import { Tooltip, TooltipType } from "by/gamefactory/cityversetycoon/scenes/common/components/Tooltip";
import { MyBuildingsTutorialResourcePackage } from "../../resources/MyBuildingsTutorialResourcePackage";

export class UpgradeTutorialSecondTooltipComponent extends Container {
    private static readonly UPGRADE_TEXT = "UPGRADE";
    private static readonly ITEMS_TEXT = "ITEMS";
    private static readonly TO_RAISE_THE_TEXT = "TO RAISE THE";
    private static readonly RANK_TEXT = "RANK";
    private static readonly OF_THE_BUILDING_TEXT = "OF THE BUILDING";

    private readonly tutorialResources: MyBuildingsTutorialResourcePackage;

    private tooltip: Tooltip;
    private upgradeText: Text;
    private itemsText: Text;
    private toRaiseText: Text;
    private rankText: Text;
    private ofTheBuildingText: Text;

    public constructor(tutorialResources: MyBuildingsTutorialResourcePackage) {
        super();
        this.tutorialResources = tutorialResources;
        this.build();
        this.layout();
    }

    private build(): void {
        this.tooltip = new Tooltip(this.tutorialResources.assets_tutorials_mybuildings_tutorial_tooltip_3_png, 634, 383, TooltipType.ToTop);
        this.addChild(this.tooltip);
        this.upgradeText = new Text(UpgradeTutorialSecondTooltipComponent.UPGRADE_TEXT, new UpgradeTutorialGreenTextStyle());
        this.addChild(this.upgradeText);
        this.itemsText = new Text(UpgradeTutorialSecondTooltipComponent.ITEMS_TEXT, new UpgradeTutorialWhiteTextStyle());
        this.addChild(this.itemsText);
        this.toRaiseText = new Text(UpgradeTutorialSecondTooltipComponent.TO_RAISE_THE_TEXT, new UpgradeTutorialWhiteTextStyle());
        this.addChild(this.toRaiseText);
        this.rankText = new Text(UpgradeTutorialSecondTooltipComponent.RANK_TEXT, new UpgradeTutorialPurpleTextStyle());
        this.addChild(this.rankText);
        this.ofTheBuildingText = new Text(UpgradeTutorialSecondTooltipComponent.OF_THE_BUILDING_TEXT, new UpgradeTutorialWhiteTextStyle());
        this.addChild(this.ofTheBuildingText);
    }

    private layout(): void {
        this.upgradeText.position.set(166, 156);
        this.itemsText.position.set(353, 156);
        this.toRaiseText.position.set(128, 226);
        this.rankText.position.set(392, 226);
        this.ofTheBuildingText.position.set(158, 295);
    }
}